// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyRequestModel from '../../model/get-company-request-model';
import GetCompanyRequestDTO from '../dto/get-company-request-dto';
import dtoSchema from '../schemas/get-company-request-schema';

export default abstract class GetCompanyRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetCompanyRequestDTO>): GetCompanyRequestModel;
  static toModel(dto: DeepPartial<GetCompanyRequestDTO> | undefined | null): GetCompanyRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyRequestDTO> | undefined | null): GetCompanyRequestModel | undefined {
    return dto ? new GetCompanyRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyRequestModel> | GetCompanyRequestModel): GetCompanyRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetCompanyRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyRequestModel, can not map to GetCompanyRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
